module.exports = __webpack_public_path__ + "img/c3-bg.710bb933.jpg";